<nav class="navbar sticky-top navbar-expand-lg" id="general-navbar">
    <div class="container-fluid">

        <a href="/home" id="header-logo" class="navbar-brand">
            <img src="../../../assets/images/Tecnalia_Logo_Mini.jpg"
                draggable="false"
                alt="Logo"
                class="logo-img">
        </a>

        <div class="collapse navbar-collapse">
            <ul class="navbar-nav ms-auto">

                @if (this.isAdmin) {
                    <li class="nav-item" (click)="navigateTo('administration')">
                        <a class="nav-link" [ngClass]="{ 'active': selectedRole === 'Administrator' }">
                            {{ 'HEADER.ADMINISTRATOR' | translate }}
                        </a>
                    </li>
                }

                <li class="nav-item" (click)="navigateTo('catalog')">
                    <a class="nav-link" [ngClass]="{ 'active': selectedRole === 'Catalog' }">
                        {{ 'HEADER.CATALOG' | translate }}
                    </a>
                </li>

                <li class="nav-item dropdown" [class.show]="isDropdownOpen">
                    <button class="btn btn-primary dropdown-toggle" type="button" (click)="toggleDropdown()">
                        {{ this.user?.username }}
                    </button>
                    <ul class="dropdown-menu" #dropdownMenu [class.show]="isDropdownOpen">
                        <!-- <li>
                            <a class="dropdown-item disabled" id="dropdown-top">
                                {{ 'HEADER.PROFILE' | translate }}
                            </a>
                        </li> -->
                        <li>
                            <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling">
                                {{ 'HEADER.LANGUAGE' | translate }}
                            </a>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li>
                            <a class="dropdown-item" id="dropdown-bottom" (click)="logout()">
                                {{ 'HEADER.LOGOUT' | translate }}&nbsp;
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#FB2528" class="bi bi-box-arrow-right" viewBox="0 2 16 16">
                                    <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
                                    <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </div>

    </div>
</nav>

<!-- LANGUAGE OFFCANVAS -->
<div class="offcanvas offcanvas-start" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasScrollingLabel">{{ 'HEADER.LANGUAGE' | translate }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        <ul class="language-menu">
            @for (lang of languages; track lang) {
                <li>
                    <a class="dropdown-item" (click)="changeLang(lang.code)" data-bs-dismiss="offcanvas">
                        <img [src]="'assets/flags/1x1/' + lang.flagcode + '.svg'" [alt]="lang.label + ' flag'" width="20" height="20">
                        <span>{{ lang.label }}</span>
                    </a>
                </li>
            }
        </ul>
    </div>
</div>